import { ConfirmModal } from '../../../../shared/modal'

type ConfirmDeleteCommentModalProps = {
  /** Determines visibility of modal */
  isOpen: boolean
  /** Event callback when Confirm Button is triggered */
  onConfirm: () => void
}

const ConfirmDeleteCommentModal = ({ isOpen, onConfirm }: ConfirmDeleteCommentModalProps) => (
  <ConfirmModal
    confirmText="Delete Comment"
    isOpen={isOpen}
    onConfirm={onConfirm}
    title="Delete Comment"
  >
    Are you sure you want to delete the comment?
  </ConfirmModal>
)

export default ConfirmDeleteCommentModal
